import React from "react";

export interface PageInfo {
  label: string;
  icon?: React.ComponentType<any> | null;
}

type TitleListener = (pageInfo: PageInfo | null) => void;

let pageInfo: PageInfo | null = null;
let listeners: TitleListener[] = [];

const notifyListeners = () => {
  for (const listener of listeners) {
    listener(pageInfo);
  }
};

const setPageInfo = (newPageInfo: PageInfo) => {
  pageInfo = newPageInfo;
  document.title = newPageInfo.label;
  notifyListeners();
};

const getPageInfo = (): PageInfo | null => {
  return pageInfo;
};

const subscribe = (listener: TitleListener): (() => void) => {
  listeners.push(listener);
  return () => {
    listeners = listeners.filter((l) => l !== listener);
  };
};

const clearPageInfo = () => {
  pageInfo = null;
  notifyListeners();
};

export const titleService = {
  setPageInfo,
  getPageInfo,
  subscribe,
  clearPageInfo,
};
